import { Component, OnInit, Inject, Input } from '@angular/core';
import { faPlus, faTimes, faShare } from '@fortawesome/pro-light-svg-icons';
import { TransactionsService } from '../../../shared/services/transactions-service';
import { AddTransactionComponent } from './add-transaction/add-transaction.component';
import { DateTime } from 'luxon';
import { KlyantService } from '../../../shared/services/klyant.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { YesNoPopupComponent } from 'src/app/shared/components/yes-no-popup/yes-no-popup.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/shared/services/toast.service';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss']
})
export class TransactionsComponent implements OnInit {

  @Input() caseId : number;
  @Input() caseTypeId : number;

  transactions: any[] = [];
  transactionsAdded: any[] = [];
  transactionsRemoved: any[] = [];
  officeAccountList: any[] = [];
  clientAccountList: any[] = [];
  balance: number = 0;
  faPlus = faPlus;
  faTimes = faTimes;
  faShare = faShare;

  constructor(
  private transactionService: TransactionsService,
  private modalService: ModalService,
  private klyantService: KlyantService,
  private toastService: ToastService,
  public activeModal: NgbActiveModal
) {

  }

  ngOnInit(): void {

    this.klyantService.getOfficeAccounts().subscribe((results) => {
      this.officeAccountList = results;

      this.klyantService.getClientAccounts().subscribe((results) => {
        this.clientAccountList = results;

        this.loadTransactions();
      }); 
    }); 
  }

  loadTransactions() {

    this.transactions = [];
    this.transactionsAdded = [];
    this.transactionsRemoved = [];

    this.transactionService.getTransactions(this.caseId).subscribe((results) => {
      this.balance = results.balance;
      results.addedAndCurrent.forEach((t:any) => {
        if (t.transactionDirection == 1) {          
          t.type = 'Receipt';
          this.transactionsAdded.push(t);
        }
        else if (t.transactionDirection == 2) {
          t.type = 'Transfer';
          this.transactionsAdded.push(t);
        }
        else if (t.transactionDirection == 3) {          
          t.type = 'Payment';
          this.transactionsAdded.push(t);
        }
        else {
          console.log('Got transaction with Id=' + t.matterLedgerId + ' with unknown type');
        }
      });
    });
  }

  getOfficeAccountName(id:number) {
    var account = this.officeAccountList.filter(x => x.id == id);
    if(account && account.length == 1) {
      return account[0].bank;
    }
    else {
      return null;
    }
  }

  getClientAccountName(id:number) {
    var account = this.clientAccountList.filter(x => x.id == id);
    if(account && account.length == 1) {
      return account[0].name;
    }
    else {
      return null;
    }
  }

  addTransaction(){

    const modalRef = this.modalService.openWithOptions(AddTransactionComponent, { size: 'lg' });
                          
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.caseTypeId = this.caseTypeId;

    modalRef.result.then(
      (result) => {
         if (result){ 
        this.loadTransactions();
        }
      },
      () => {} // dismissed - do nothing
    );
  }

  removeTransaction(matterLedger:any) {

     var popupText = '';
    if(matterLedger.klyantId)
    {
      popupText = 'THIS ITEM HAS BEEN SENT TO KLYANT. YOU MUST VOID THE TRANSACTION IN KLYANT MANUALLY.';
    }

    const modalRef = this.modalService.openWithOptions(YesNoPopupComponent, { size: 'lg' });
                          
    modalRef.componentInstance.messageHeader = 'Are you sure you want to remove this transaction?';
    modalRef.componentInstance.popupText1 = popupText;

    modalRef.result.then(
      (result) => {
        if (result)
        {
          this.transactionService.removeTransaction(this.caseId, matterLedger.matterLedgerId).subscribe(() => {
            this.loadTransactions();
          });
        }
      },
      () => {} // dismissed - do nothing
    );
  
  }

  sendToKlyant(matterLedger:any) {   
    matterLedger.sendingToKlyant = true;
    this.transactionService.sendToKlyant(this.caseId, matterLedger.matterLedgerId).subscribe((response : any) => {      
      
      matterLedger.sendingToKlyant = true;
      this.loadTransactions();
      this.toastService.success("Transaction Sent to Klyant");
    }, (error: any) => {            
      matterLedger.sendingToKlyant = false;
      this.toastService.error("ERROR: " + error.error);
    });
  }


}
